// @ts-nocheck
import { graphql } from "gatsby"

import { Box } from "@mui/material"
import { get } from "lodash"

import { mapPageData } from "../../helpers/data-mappers"
import GeoPageView from "../../templates/geoPage-view.tsx"
import SEOHead from "../head"

export default function StateView(props) {
  const state = get(props, "data.nodeState", {})

  if (!state) {
    return <Box>{"State not found"}</Box>
  }

  const mappedData = mapPageData(state)

  return (
    <>
      {ComposeHead(props)}
      <GeoPageView data={mappedData} />
    </>
  )
}

export const ComposeHead = (props) => {
  const { nodeState } = props.data
  const metatag = get(nodeState, "metatag.items")
  const url = get(nodeState, "slug")
  return <SEOHead metas={metatag} url={url} />
}

export const query = graphql`
  query StateTemplateQuery($id: String!) {
    nodeState(id: { eq: $id }) {
      id
      external_id
      slug
      title
      metatag {
        items {
          content
          name
        }
      }
      country {
        ...GeoCountryReferenceFragment
      }
      hero {
        ...HeroFragment
      }
      content_highlight {
        ...ContentHighlightFragment
      }
      vmedia_content {
        ...VisualMediaContentFragment
      }
      contact_cta {
        ...ContactCtaFragment
      }
      facts_overview {
        ...FactsOverviewFragment
      }
      teaser_3up {
        ...Teaser3UpFragment
      }
      suggested_trips {
        ...SuggestedTripsFragment
      }
      section_switcher {
        ...SectionSwitcherFragment
      }
    }
  }
`
